// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__nC4yD","label":"styles_label___vz6U","icon":"styles_icon__zEkdq"};